export default __webpack_public_path__ + "static/media/avatar.3d6ee070.png";